export const SET_SIDENAV_SLIM = 'action.set.sidenav.slim';

export const setSidenavSlim = isSidenavSlim => ({
    type: SET_SIDENAV_SLIM,
    isSidenavSlim,
});
